import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PageHeader } from '@/components/shared/page-header'

export const Route = createFileRoute('/_app/social-listening')({
  component: SocialListeningLayout,
})

function SocialListeningLayout() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Social Listening"
        description="Monitore menções da sua marca no Instagram e descubra novos creators."
      />

      <div>
        <Outlet />
      </div>
    </div>
  )
}
